import * as React from "react";

/** Tracks the hovered bar and positions the tooltip relative to the chart's SVG. */
export const useBarTooltip = () => {
  const [hoveredIndex, setHoveredIndex] = React.useState<number | null>(null);
  const [tooltipPosition, setTooltipPosition] = React.useState({ x: 0, y: 0 });

  const handleMouseEnter = (event: React.MouseEvent<SVGRectElement, MouseEvent>, index: number) => {
    setHoveredIndex(index);
    const rect = event.currentTarget.closest("svg")!.getBoundingClientRect();
    setTooltipPosition({
      x: event.clientX - rect.left + 10,
      y: event.clientY - rect.top - 10,
    });
  };

  const handleMouseLeave = () => setHoveredIndex(null);

  return { hoveredIndex, tooltipPosition, handleMouseEnter, handleMouseLeave };
};
